import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';

export const getUrl = (baseUrl: BaseUrl) =>
	`${baseUrl}/rest/workinghours/1/api/calendar/parseIcs?operation=calendarImport`;
